import { useEffect, useState } from "react";
import { Dialog } from "@mui/material";
import { toast } from "react-toastify";
import { HStack, VStack } from "../../components/utils";
import {
  ButtonSize,
  PrimaryCTAButton,
  SecondaryCTAButton,
} from "../quickRound/CTAButtonComponents";
import { InvestorDetails, ModelState } from "../../types/Modeling";
import CreateNewnvestorModal from "./CreateNewInvestorModal";
import DeleteModal from "../modeling/DeleteModal";
import { useRoundModelStore } from "../../store/roundModelingStore";
import NewInvestorAGGridTable from "./NewInvestorAgTable";
import { queryClient } from "../../queries";

export default function NewInvestorsTab() {
  const [dialog, setDialog] = useState<{
    open: boolean;
    mode?: string;
    data?: InvestorDetails;
  }>({
    open: false,
  });
  const {
    roundCreation: data,
    sendMessage: onNext,
    setRoundCreation: setRoundState,
    connect,
    saveModel,
  } = useRoundModelStore();

  const showErrorMessage = () => {
    if (data.errorMessage) {
      toast(data.errorMessage, {
        type: "error",
        autoClose: 2000,
      });

      setRoundState({
        ...data,
        errorMessage: "",
      });
    }
  };

  useEffect(() => {
    showErrorMessage();
  }, [data.errorMessage]);

  function scrollToTop() {
    const scroller = document.querySelector("#outlet");
    scroller?.scrollTo(0, 0);
  }

  return (
    <VStack className="justify-between min-h-full py-4 bg-white rounded-lg ">
      <Dialog open={dialog.open} maxWidth="lg">
        {dialog.mode === "Add" && (
          <CreateNewnvestorModal
            data={dialog.data}
            onBack={() => {
              setDialog({
                open: false,
              });
            }}
            onNext={onNext}
            actionMode="New"
          />
        )}
        {dialog.mode === "Edit" && (
          <CreateNewnvestorModal
            data={dialog.data}
            onBack={() => {
              setDialog({
                open: false,
              });
            }}
            onNext={onNext}
            actionMode="Edit"
          />
        )}
        {dialog.mode === "Delete" && (
          <DeleteModal
            onPrimaryAction={() => setDialog({ open: false })}
            onSecondaryAction={() => setDialog({ open: false })}
            data={
              "Are you sure you want to delete the entry? Data will be permanently removed. This action cannot be undone."
            }
          />
        )}
      </Dialog>

      <div>
        <VStack className="px-2">
          <NewInvestorAGGridTable
            data={data.newInvestorDetails?.investorDetails || []}
          />
        </VStack>
      </div>
      <HStack className="justify-between gap-4 px-6 mt-8">
        <HStack className="gap-4">
          <SecondaryCTAButton
            type="reset"
            event-name="New Investor Tab Back"
            buttonSize={ButtonSize.SMALL}
            onClick={() => {
              onNext({ ...data, currentTab: 3 });
              scrollToTop();
            }}
          >
            Back
          </SecondaryCTAButton>
        </HStack>
        <HStack>
          <div className="justify-end pr-4 ">
            <PrimaryCTAButton
              className="h-8"
              event-name="Save Model Button"
              onClick={() => {
                connect();
                saveModel(data);

                toast(
                  `Saved ${data?.roundDetailsTab?.roundName} round model successfully`,
                  {
                    type: "success",
                    autoClose: 2000,
                  }
                );
                queryClient.invalidateQueries("listofmodeling");
              }}
              buttonSize={ButtonSize.SMALL}
            >
              Save Model
            </PrimaryCTAButton>
          </div>
          <PrimaryCTAButton
            event-name="New Investor Tab Next"
            buttonSize={ButtonSize.SMALL}
            onClick={() => {
              setRoundState({
                ...data,
                isNavigating: true,
              });
              onNext({
                ...data,
                currentTab: 5,
              });
              queryClient.invalidateQueries("listofmodeling");
              scrollToTop();
            }}
            loading={data.isNavigating}
            className="min-w-max"
            type="submit"
          >
            Next
          </PrimaryCTAButton>
        </HStack>
      </HStack>
    </VStack>
  );
}
